import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-heatmap-help',
  templateUrl: './heatmap-help.component.html',
  styleUrls: ['./heatmap-help.component.scss'],
})
export class HeatmapHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
